module.exports = "/assets/68ce3c6c17cd0a2d765c90e2c3e9566b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WN.png
// module id = 1966
// module chunks = 0